<template>
  <div class="loader">
    <slot />
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({ name: "Loader" });
</script>
<style scoped lang="scss">
.loader {
  width: 100%;
  opacity: 0;
  animation-delay: 120ms;
  animation-name: fade-in;
  animation-duration: 800ms;
  animation-fill-mode: forwards;
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
</style>
